<template>
  <!--
      	作者：kmdshop
      	时间：2020-06-01
      	描述：插件中心-分销-提现申请-弹窗
      -->

  <el-dialog title="统计" :visible.sync="dialogVisible" @close="dialogFormVisible" 
  :close-on-click-modal="false" :close-on-press-escape="false"
  style="width: 120%;">
      <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择等级">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item,index) in grade" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属团队">
          <el-select v-model="formInline.user_team_id" placeholder="请选择所属团队">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item,index) in team" :key="index" :label="item.name" :value="item.user_team_id"></el-option>
          </el-select>
        </el-form-item>
 
        <el-form-item label=""><el-input v-model="formInline.search" placeholder="请输入ID/昵称/姓名/手机号"></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="getData(true)">查询</el-button></el-form-item>
        <el-form-item><el-button  type="button" @click="reast">重置</el-button></el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="用户ID" width="60"></el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img class="radius" v-img-url="scope.row.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称" width="100"></el-table-column>
          <!--          <el-table-column prop="real_name" label="姓名"></el-table-column>-->
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="grade.name" label="等级"></el-table-column>
          <el-table-column prop="userTeam.name" label="所属团队">
            <template slot-scope="scope" v-if="scope.row.userTeam && scope.row.userTeam.name">
              <div>{{ scope.row.userTeam.name }}({{scope.row.userTeam.numb  }})</div>
             </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="150">
            <template slot-scope="scope">
              <p class="text-ellipsis" :title="scope.row.mobile">{{ scope.row.mobile }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="提现金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.true_money }}</span>
            </template>
          </el-table-column>
           <el-table-column prop="true_money" label="实际获得金额">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cash_fee" label="提现手续费">
            <template slot-scope="scope">
              <span class="orange">{{ scope.row.cash_fee }}</span>
            </template>
          </el-table-column>
  
    

        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          :page-sizes="[5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
          layout="total, prev, sizes, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    </el-dialog>


</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline: {
        search: '',
        user_team_id:-1,
        grade_id:-1,
      },
      status: '',
      reject_reason: '',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      team:[],
      grade:[],
    };
  },
  props: ['open_edit', 'form','user_id'],
  created() {
    this.dialogVisible = this.open_edit;
    this.formInline.search = this.user_id
    this.getUserTeam();
    this.getData();
  },
  methods: {
    reast(){
      this.formInline = {
        search: '',
        /*用户ID*/
        user_id: '',
        user_team_id:-1,
        grade_id:-1,
      }
      this.getData();
    },
    getUserTeam(){
      let self = this;
      self.loading = true;
      PlusApi.getUserTeam({}, true)
        .then(data => {
          self.team  = data.data.team;
          self.grade = data.data.grade

        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*修改*/
    getData(submit = false) {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      Params.page = submit ? 1 : self.curPage;
      Params.list_rows = self.pageSize
      PlusApi.cashStatics(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
       /*每页多少条*/
       handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/cash/dialog/Statics.vue